import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { changeWbMarket } from '../../../actions/wb';
import MarketCommonApi from '../../../API/market/common-api';
import MarketWbApi from '../../../API/market/wb-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Link } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { TextGrey } from '../../../components/Basic/WrapsStyle';
import {
  MARKETS_ALL,
  MARKETS_MAP,
  TYPE_BUTTONS,
  WB_1,
  WB_2,
  WB_3,
  WB_4,
  WB_5,
  WB_6,
  WB_7,
  WB_MARKET_IP,
  WB_MARKETS_MAP
} from '../../../constans';
import styles from './styles.module.scss';
import WbTable from './Table';

const WbPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const user = useSelector((store) => store.user);
  const shop = useSelector((store) => store.wb.market);
  const [isFbsRemainsMode, setIsFbsRemainsMode] = useState(location.pathname === '/fbo/fbswb')
  const [update, setUpdate] = useState(false)
  // const [shopsWbInfo, setShopsWbInfo] = useState(MARKETS_ALL['wb'].map(s => ({ shop: s })));
  const [marketInfo, setMarketInfo] = useState({});

  useEffect(() => { }, [update])

  useEffect(() => {
    MarketCommonApi.getMarketInfo({ data: { market: 'wb' } }).then((r) => setMarketInfo(r.marketInfo));
    // MarketCommonApi.getShopsInfo({ data: { market: 'wb' } }).then(r => setShopsWbInfo(r.shopsInfo))
  }, [])

  const updateProviderStocks = async (providerId = undefined, isNullStock = false, offerIds = undefined) => {
    return await MarketWbApi.updateStocks({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          providerId,
          offerIds,
        },
        rules: {
          nullProvider: isNullStock,
          nullWarehouse: isNullStock,
        },
      },
    });
  };

  const updateProviderPrice = async (providerId = undefined, offerIds = undefined, ignoreDiffPrice = undefined, waitEnd) => {
    return await MarketWbApi.updatePrices({
      data:
      {
        shop: MARKETS_MAP[shop],
        filter: {
          providerId,
          offerIds,
          ...(isFbsRemainsMode && { onlyActiveFbsProducts: true })
        },
        rules: {
          ignoreDiffPrice,
        },
        skladName: 'msk',
        waitEnd,
      }
    });
  };

  const updateExpressPrice = async () => {
    return await MarketWbApi.updatePrices({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          onlyExpress: true,
        },
        skladName: 'msk',
      }
    });
  };

  const updateWarehouseWBProductPrice = async () => {
    await MarketWbApi.updateStocks({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          onlyWarehouseWb: true,
          nullProvider: true,
        },
        rules: {
          nullProvider: true,
        },
        skladName: 'msk',
        waitEnd: true,
      }
    });

    await MarketWbApi.updateStocks({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          onlyWarehouseWb: true,
        },
        rules: {
          nullProvider: true,
        },
        skladName: 'ekb',
        waitEnd: true,
      }
    })

    await MarketWbApi.updatePrices({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          onlyWarehouseWb: true,
        },
        rules: {
          ignoreDiffPrice: true,
        },
        skladName: 'msk',
      }
    })
  };

  const updateExpressStocks = async (skladName, isNullStock = false) => {
    return await MarketWbApi.updateStocks({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          onlyExpress: true,
          onlyProvider: false,
        },
        rules: {
          nullWarehouse: isNullStock,
        },
        skladName,
      }
    });
  };

  const updateCCStocks = async (skladName, isNullStock = false) => {
    return await MarketWbApi.updateStocks({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          onlyCC: true,
          onlyProvider: false,
        },
        rules: {
          nullWarehouse: isNullStock,
        },
        skladName,
      }
    });
  };


  const isOwner = user.role === 'owner' || user.role === 'admin';

  const isContent = user.role === 'user';

  return (
    <Content>
      <Row style={{ alignItems: 'flex-start' }}>
        <WhiteBlock
          title="Управление"
          title_bold={`Wildberries ${shop} (${WB_MARKET_IP[shop]})`}
          style={{ marginRight: '30px' }}
          minimize={!isFbsRemainsMode}

        >
          <Row style={{ alignItems: 'stretch' }}>
            <Column>
              <Select
                style={{ marginBottom: '30px' }}
                label="Магазин"
                select={shop}
                width="180px"
                list={[WB_1, WB_2, WB_3, WB_4, WB_5, WB_6, WB_7]}
                onSelect={(v) => dispatch(changeWbMarket(v))}
              />
              {isFbsRemainsMode &&
                <Column>
                  <Row>
                    <SendButton
                      sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                      sendApi={MarketWbApi.uploadStocksAndPrices}
                      style={{ marginRight: '15px' }}
                      endLoad={() => setUpdate(!update)}
                    >
                      Подгрузить остатки
                    </SendButton>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => {
                        MarketWbApi.excelStocksAndPricesTmp({ data: { shop: MARKETS_MAP[shop] } })
                      }}
                      style={{ marginLeft: '10px' }}
                    >
                      Скачать шаблон
                    </Button>
                  </Row>
                  <Row
                    style={{ marginTop: '15px' }}
                  >
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={async () => {
                        await MarketWbApi.updateStocks({
                          data: {
                            shop: MARKETS_MAP[shop],
                            filter: {},
                            rules: {
                              fbsActiveUpdate: true
                            },
                            skladName: 'msk',
                            waitEnd: true,
                          }
                        })
                        setUpdate(!update)
                      }}
                    >
                      Отправить остатки
                    </Button>
                    <Button
                      style={{ marginLeft: '30px' }}
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => {
                        MarketWbApi.excelStocksFbsActive({ data: { shop: MARKETS_MAP[shop] } })
                      }}
                    >
                      Скачать остатки
                    </Button>
                  </Row>
                </Column>

              }
              {(isOwner && !isFbsRemainsMode) && (
                <>
                  <Row style={{ marginTop: '10px' }}>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => MarketWbApi.loadCards({ data: { shop: MARKETS_MAP[shop] } })}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить номенклатуры
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => MarketWbApi.loadCards({ data: { shop: MARKETS_MAP[shop], onlyNew: true } })}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить новую номенклатуры
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => MarketWbApi.loadBasketedCards({ data: { shop: MARKETS_MAP[shop] } })}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить корзину
                    </Button>

                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => MarketWbApi.loadWarehouseStocks({ data: { shop: MARKETS_MAP[shop] } })}
                      style={{ margin: '0 10px' }}
                    >
                      Выгрузить остатки WB
                    </Button>
                  </Row>
                  {isOwner && !isFbsRemainsMode && (
                    <Row style={{ marginTop: '15px', alignItems: 'flex-start' }}>
                      <Column>
                        <SendButton
                          sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                          sendApi={MarketWbApi.updateByExcel}
                          style={{ marginRight: '15px' }}
                        >
                          Подгрузить данные
                        </SendButton>
                        <Link
                          download
                          href="/public/template.xlsx"
                          name="Шаблон wb товары --- не работает"
                          className={styles.link_download}
                        >
                          Скачать шаблон
                        </Link>
                      </Column>
                      <Button
                        type={TYPE_BUTTONS.BLUE}
                        onClick={() => MarketWbApi.calculateCommission({ data: { shop: MARKETS_MAP[shop] } })}
                        style={{ marginRight: '10px' }}
                      >
                        Выгрузить цены
                      </Button>
                      <Button
                        type={TYPE_BUTTONS.BLUE}
                        onClick={() => MarketWbApi.calculateCommission({ data: { shop: MARKETS_MAP[shop], onlyNew: true } })}
                        style={{ marginRight: '10px' }}
                      >
                        Выгрузить цены для новинок
                      </Button>
                      <Button
                        type={TYPE_BUTTONS.BLUE}
                        onClick={() => MarketWbApi.loadCategories({})}
                        style={{ marginRight: '10px' }}
                      >
                        Выгрузить категории
                      </Button>
                    </Row>
                  )}
                </>
              )}
            </Column>
            {isOwner && !isFbsRemainsMode && (
              <Column className={styles.stosks_column}>

                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    onClick={() => updateExpressStocks('msk')}
                    style={{ marginRight: '15px', width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обновить остатки EXPRESS MSK
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    onClick={() => updateExpressStocks('msk', true)}
                    style={{ width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обнулить остатки EXPRESS MSK
                  </Button>
                </Row>

                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    onClick={() => updateExpressStocks('ekb')}
                    style={{ marginRight: '15px', width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обновить остатки EXPRESS EKB
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    onClick={() => updateExpressStocks('ekb', true)}
                    style={{ width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обнулить остатки EXPRESS EKB
                  </Button>
                </Row>

                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    onClick={() => updateCCStocks('msk')}
                    style={{ marginRight: '15px', width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обновить остатки CC MSK
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    onClick={() => updateCCStocks('msk', true)}
                    style={{ width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обнулить остатки CC MSK
                  </Button>
                </Row>

                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    onClick={() => updateCCStocks('ekb')}
                    style={{ marginRight: '15px', width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обновить остатки CC EKB
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    onClick={() => updateCCStocks('ekb', true)}
                    style={{ width: '100%' }}
                    disabled={shop !== WB_1}
                  >
                    Обнулить остатки CC EKB
                  </Button>
                </Row>



                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() => updateExpressPrice()}
                    style={{ marginRight: '10px' }}
                  >
                    Пересчитать цены для Express
                  </Button>
                  <Button type={TYPE_BUTTONS.WHITE} onClick={() => updateWarehouseWBProductPrice()}>
                    Пересчитать цены для товаров на складе вб
                  </Button>
                </Row>
              </Column>
            )}
          </Row>
        </WhiteBlock>
        {isFbsRemainsMode && (
          <>
            <WhiteBlock title="Управление отгрузками FBS" left={true} minimize={true} openBlock={true}>
              <Row style={{ alignItems: 'start' }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: 'stretch', justifyContent: 'space-between' }}>
                  <div style={{ marginTop: '0px', textAlign: 'center', fontWeight: 'bold', color: '#0000009e' }}>Рассчёт цен</div>
                  <div style={{ border: '2px solid #0000006c', padding: '15px', marginTop: '15px', borderRadius: '5px', width: '320px' }}>
                    <Row style={{ justifyContent: 'space-between' }}>
                      <TextGrey>Коеффициент логистики, %</TextGrey>
                      <Input
                        center
                        style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={marketInfo?.commission?.delivery_sort_center?.coef}
                        onBlur={async (v) => {
                          setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.delivery_sort_center.coef', value: +v } }).then(r => r.marketInfo))
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Логистика первого литра</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={true}
                        value={marketInfo?.commission?.delivery_sort_center?.first_liter_base}
                      // onBlur={async (v) => {
                      // const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.delivery.liter', value: v } }).then(r => r.supply)
                      // }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Логистика последующего литра</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={true}
                        value={marketInfo?.commission?.delivery_sort_center?.step_liter_base}
                      // onBlur={async (v) => {
                      // setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.delivery_sort_center.step_liter_base', value: +v } }).then(r => r.marketInfo))
                      // }}
                      />
                    </Row>
                  </div>
                  <Row style={{ marginTop: '15px', justifyContent: 'space-between' }}>
                    <TextGrey>Маржинальность, %</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.marginality?.percent}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'marginality.percent', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                    <TextGrey>Маржинальность мин, руб.</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.marginality?.rub}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'marginality.rub', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                    <TextGrey>Повышенная комиссия, %.</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.commission?.increased_commission?.percent}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.increased_commission.percent', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                    <TextGrey>Стоимость короба, руб.</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.common_commission?.box_cost}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'common_commission.box_cost', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    style={{
                      backgroundColor: false ? '#ed6e14d3' : '',
                      marginTop: '20px'
                    }}
                    disabled={!isOwner}
                    onClick={async () => {
                      await MarketWbApi.updatePrices({ data: { shop: WB_MARKETS_MAP[shop], skladName: 'msk', filter: { onlyActiveFbsProducts: true }, rules: {}, waitEnd: true } })
                      setUpdate(!update)
                    }}
                  >
                    Пересчитать цены
                  </Button>
                </div>
              </Row>

            </WhiteBlock>
          </>
        )}
      </Row>
      <WbTable
        parentUpdate={update}
        setIsFbsRemainsMode={setIsFbsRemainsMode}
        isFbsRemainsMode={isFbsRemainsMode}
        updateProviderStocksAndPrice={updateProviderStocks}
        updateProviderPrice={updateProviderPrice} />
    </Content>
  );
};

export default WbPage;
